<template>
  <div class="search-button">
    <router-link class="search-button__action" :to="getRouterLink">
      <base-button :disabled="!carCount" @click.native="resetCarList">{{
        `${$t("shared.search")} (${carCount})`
      }}</base-button>
    </router-link>
  </div>
</template>

<script>
import { GET_DATA_FROM_API } from "@/store/actionTypes";
import { RESET_PAGE } from "@/store/mutationTypes";
import { internalLinks } from "@/constants/links";
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";

export default {
  name: "SearchButton",
  components: {
    BaseButton
  },
  computed: {
    carCount() {
      return this.$store.state.carCount;
    },
    getRouterLink() {
      return this.$route.name === "dealerSearch"
        ? `/dealer/${this.$route.params.dealerName}/results`
        : internalLinks.results;
    }
  },
  methods: {
    resetCarList() {
      this.$store.commit(RESET_PAGE);
      this.$store.dispatch(GET_DATA_FROM_API);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-button {
  position: sticky;
  bottom: 0;
  padding: 23px 20px 19px;
  box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, .1);
  background-color: $color-white;
  z-index: $z-index-3;
}

@media screen and (min-width: $media-xl) {
  .search-button {
    @include grid-columns(12);

    &__action {
      @include grid-columns-from-to(2, 12);
    }
  }
}

@media screen and (min-width: $media-xl),
  (-ms-high-contrast: active),
  (-ms-high-contrast: none) {
  .search-button__action {
    display: flex;
  }
}
</style>
